<template>
  <div>
    <vs-popup
      v-if="boardUserData"
      class="profile-card"
      :title="boardUserData.userData.firstName + `'s Profile Card`"
      :active.sync="profileCardPopupActive"
      :button-close-hidden="true"
    >
      <profile-card-popup :boardUserData="boardUserData" />
    </vs-popup>

    <div class="flex items-center">
      <vs-avatar
        v-if="params.data.userData && params.data.userData.profilePictureUrl"
        @click="userProfilePopup(params.value)"
        class="flex-shrink-0 mr-2"
        size="30px"
        :src="
          constants.s3Bucket +
          '/editor/profile-pictures/' +
          params.data.userData.profilePictureUrl
        "
      />
      <vs-avatar
        v-else
        @click="userProfilePopup(params.value)"
        class="flex-shrink-0 mr-2"
        size="30px"
        :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
          params.data.userData.firstName,
          params.data.userData.lastName
        )}`"
      />

      <div
        @click="userProfilePopup(params.value)"
        class="text-inherit hover:text-primary cursor-pointer"
      >
        {{ params.value }}
      </div>
    </div>
    <!-- <vs-avatar :src="params.data.avatar" class="flex-shrink-0 mr-2" size="30px" @click="userProfilePopup(params.value)" />
    <div @click="userProfilePopup(params.value)" class="text-inherit hover:text-primary">{{ params.value }}</div> -->
  </div>
</template>

<script>
import _ from "lodash";
import constants from "@/constants.js";
import ProfileCardPopup from "../../../components/ProfileCardPopup.vue";

export default {
  name: "CellRendererLink",
  data() {
    return {
      profileCardPopupActive: false,
      boardUserData: null,
      constants,
    };
  },
  components: {
    ProfileCardPopup,
  },
  computed: {
    currentBoardUsers() {
      return this.$store.state.boards.currentBoardUsers;
    },
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
  },
  methods: {
    userProfilePopup(email) {
      this.boardUserData = _.find(this.currentBoardUsers, (cbu) => {
        return cbu.userData.email === email;
      });
      if (this.boardUserData) {
        this.profileCardPopupActive = true;
      }
    },
  },
};
</script>

<style scoped>
.user-name--item h4 {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 27px;
  /* identical to box height */

  letter-spacing: -0.02em;
  text-transform: capitalize;

  color: #192a46;
}

.user-name--item span {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */

  display: flex;
  align-items: center;

  color: #636175;
}
.level--item {
  background: rgba(36, 98, 238, 0.1);
  border-radius: 4px;
}

.level--item h4 {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 17px;
  /* identical to box height */
  display: flex;
  align-items: center;
  color: #2462ee;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 10px;
}

.user-details--item .location {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */
  display: flex;
  align-items: center;
  color: #a3a3a3;
}

.message-btn {
  background: #f4f6f8;
  border-radius: 6px;

  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  letter-spacing: -0.02em;

  color: #081343;
}

.profile-card .name {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 34px;
  line-height: 41px;
  letter-spacing: -0.02em;
  /* Licorice */
  color: #30384b;
}

.profile-card .role-title {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 29px;
  /* Light Slate Grey */
  color: #798ba0;
}

.profile-card .current-location,
.profile-card .email {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  /* Echo Blue */
  color: #b2bac8;
}

.profile-card .heading {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 13px;
  /* identical to box height, or 93% */
  letter-spacing: 0.03em;
  text-transform: uppercase;
  /* Echo Blue */
  color: #b2bac8;
}

.profile-card .content {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 23px;
  /* or 144% */
  /* Light Slate Grey */
  color: #798ba0;
}

.profile-card >>> .vs-popup--header {
  display: none !important;
}

.profile-card >>> .vs-popup {
  width: 950px;
}

.con-vs-popup >>> .vs-popup--content {
  padding: 0 !important;
  margin: 0 !important;
  overflow-x: hidden !important;
  width: auto !important;
  border-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
</style>
